import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

const InsufficientFundsInfo = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the browser title
    document.title = 'Skip a Pay | MAX Credit Union';
  }, []);

  useEffect(() => {
    // Add any necessary validation or data fetching here
  }, [navigate]);

  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {isCollapsed && <TopMenu />}
      <div style={{ display: 'flex', flex: 1 }}>
        <SideMenu menuItems={menuItems} />
        <div style={{ flex: 1, padding: '20px 20px 20px 260px', overflow: 'auto' }}>
          <style type="text/css">
            {`
              .btnwrapper {padding: 20px;}
              .ctr {text-align: center;}
              q2-btn {width: 40%;}
              body {}
              p {font-size: medium; font-weight: normal;}
              h1, h2, h3, h4, h5, h6 {font-size: large; font-weight: bold; color: #3b8ede;}

              .select-container {
                  display: flex;
                  gap: 10px;
              }

              .custom-select {
                  width: 50%; /* Takes up half of the page width */
              }

              /* Responsive image style */
              img {
                  max-width: 100%;
                  height: auto;
                  display: block;
                  margin: 0 auto;
              }

              @media screen and (max-width: 768px) {
                div[style*="padding: 20px 20px 20px 260px"] {
                  padding: 20px 20px 20px 60px !important;
                }
              }
            `}
          </style>

          <div>
            <img src="/SkipAPayHeaders-Loading.png" alt="Banner Image" />
            <br />
            <p>There are not enough funds in your account to process the Skip a Payment fee at this time. Add funds via mobile check deposit or by cash/check deposit at a <a href="https://www.mymax.com/connect/locations--atms" style={{color: '#005db9', textDecoration: 'none'}}>MAX branch</a> or <a href="https://www.coop.org/Shared-Branch-ATM" style={{color: '#005db9', textDecoration: 'none'}}>shared branch</a>. When funds are available, please try again.</p>
            <span style={{color:'#005db9'}}>Questions?</span>
            <p>Choose Chat with MAX in online banking for a shorter wait time, or call us at 334.260.2600 (local) or 1.800.776.6776 (toll-free). Representatives are available M-F 8:30 AM - 5:00 PM.</p>
          </div>


        </div>
      </div>
    </div>
  );
};

export default InsufficientFundsInfo;